import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { FormBuilderFieldTypes } from '../api/models';

@Directive({
  selector: '[fieldTypeIcon]',
  standalone: true,
})
export class FieldTypeIconDirective {
  @Input('fieldTypeIcon') fieldType: FormBuilderFieldTypes;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi tw-mx-2 ';

    switch (this.fieldType) {
      case FormBuilderFieldTypes.ShortText:
      case FormBuilderFieldTypes.BigText:
        classList += 'mdi-text mdi-21px';
        break;
      case FormBuilderFieldTypes.Boolean:
        classList += 'mdi-checkbox-blank-badge mdi-21px';
        break;
      case FormBuilderFieldTypes.Date:
        classList += 'mdi-calendar mdi-21px';
        break;
      case FormBuilderFieldTypes.DecimalNumber:
        classList += 'mdi-decimal mdi-21px';
        break;
      case FormBuilderFieldTypes.Email:
        classList += 'mdi-email mdi-21px';
        break;
      case FormBuilderFieldTypes.File:
        classList += 'mdi-file mdi-21px';
        break;
      case FormBuilderFieldTypes.Integer:
        classList += 'mdi-numeric mdi-21px';
        break;
      case FormBuilderFieldTypes.MobileNumber:
        classList += 'mdi-cellphone mdi-21px';
        break;
      case FormBuilderFieldTypes.NationalCode:
        classList += 'mdi-music-accidental-sharp mdi-21px';
        break;
      case FormBuilderFieldTypes.Regex:
        classList += 'mdi-regex mdi-21px';
        break;
      case FormBuilderFieldTypes.SelectList:
        classList += 'mdi-format-list-group mdi-21px';
        break;
      case FormBuilderFieldTypes.Time:
        classList += 'mdi-clock mdi-21px';
        break;
      default:
        break;
    }

    return classList;
  }
}
